




















import { Vue, Component, Prop } from "vue-property-decorator";
import RichiestaTirocinantiEstiviCreate from "../../components/Create/RichiestaTirocinantiEstiviCreate.vue";
import CardTitle from "../../components/CardTitle.vue";
import * as user from "../../_store/user.module";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import { router } from '../../_router';

@Component({
  components: {
    RichiestaTirocinantiEstiviCreate,
    CardTitle
  }
})
export default class RichiestaTirocinanti extends Vue {
  @Prop() idIstituto!: number;
  @Prop() idAnnoScolastico!: number;
  @Prop() idIscrizioneAttivita!: number;
  private params: object;
  private titleParams: object;
  private enterpriseInfo: EnterpriseInfo;

  constructor() {
    super();
    this.titleParams = {
      title: "RICHIESTA TIROCINANTE ESTIVO",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.params = {
      idIstituto: this.idIstituto,
      idAnnoScolastico: this.idAnnoScolastico
      // enterpriseInfo: this.enterpriseInfo
    };
    this.enterpriseInfo = {
      idAzienda: 0,
      denominazioneAzienda: "",
      titolo: "",
      cognomeRappresentanteAzienda: "",
      nomeRappresentanteAzienda: "",
      dataNascitaRappresentante: "",
      statoNascitaRappresentante: "",
      luogoNascitaRappresentante: "",
      comuneAzienda: "",
      idCapComuneAzienda: 0,
      provinciaAzienda: "",
      indirizzoAzienda: "",
      telefono1Azienda: "",
      telefono2Azienda: "",
      faxAzienda: "",
      emailAzienda: "",
      pecAzienda: "",
      sitoAzienda: "",
      attivitàAzienda: "",
      dipendentiAzienda: "",
      committenzaAzienda: "",
      associata: false,
      artigiana: false,
      pIva: "",
      codAzienda: "",
      idAteco: "",
      // idIstat: "",
      // codAteco: "",
      // codIstat: "",
      descrizioneAteco: "",
      descrizioneIstat: "",
      cap: "",
      idNazioneAzienda: "",
      nazioneAzienda: "",
      idStatoUtente: 0,
      codRappresentate: "",
      confCommercio: false,
      altraAssociazione: false
    }
  }

  created() {
    if ((this.idIstituto === undefined || this.idIstituto === null) && (this.idAnnoScolastico === undefined || this.idAnnoScolastico === null)) {
      router.push({
        name: "iscrizioneTirEstivi",
        params: {}
      });
    } else {
      this.enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    }
    // user.dispatchSetEnterpriseInfo(this["$store"])
    // .then((resp) =>{

 
    // })
  }
}
